import React from 'react';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

/**
 * Indicateur de connexion temps réel
 * Affiche l'état de la synchronisation auto avec le serveur
 */
const LiveIndicator = ({ isConnected, isPolling, lastPollTime }) => {
  const formatLastPoll = () => {
    if (!lastPollTime) return 'Jamais';
    const diff = Math.floor((new Date() - lastPollTime) / 1000);
    if (diff < 5) return 'À l\'instant';
    if (diff < 60) return `Il y a ${diff}s`;
    return `Il y a ${Math.floor(diff / 60)}min`;
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 border border-slate-200">
            {isPolling ? (
              <Loader2 className="w-3.5 h-3.5 text-blue-500 animate-spin" />
            ) : isConnected ? (
              <div className="relative">
                <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75"></span>
                <span className="relative block w-2.5 h-2.5 rounded-full bg-emerald-500"></span>
              </div>
            ) : (
              <WifiOff className="w-3.5 h-3.5 text-red-500" />
            )}
            <span className={`text-xs font-medium ${
              isConnected ? 'text-emerald-700' : 'text-red-600'
            }`}>
              {isPolling ? 'Sync...' : isConnected ? 'Live' : 'Hors ligne'}
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="bg-slate-900 text-white">
          <div className="text-xs space-y-1">
            <div className="flex items-center gap-2">
              <Wifi className="w-3 h-3" />
              <span>Synchronisation automatique</span>
            </div>
            <div className="text-slate-400">
              Dernière vérification : {formatLastPoll()}
            </div>
            {isConnected && (
              <div className="text-emerald-400 text-[10px]">
                Les données sont actualisées automatiquement
              </div>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default LiveIndicator;
